import clickOutside from './directives/click-ouside.js';
// import mask from 'vue-r-mask'
import mask from './directives/mask.js'


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', clickOutside);
    Vue.directive('mask', mask);
  }
};

export default GlobalDirectives
